import React from 'react';
import cn from 'classnames';
import styles from "./ImpersonateWarning.module.scss";
import { useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { Typography } from 'seagull';
export default function ImpersonateWarning() {
  const fakeIdentity = useStore(selectors.impersonatingAs);
  const realIdentity = useStore(state => {
    var _state$claims;
    return (_state$claims = state.claims) === null || _state$claims === void 0 ? void 0 : _state$claims.email;
  });
  return fakeIdentity && realIdentity ? /*#__PURE__*/React.createElement("div", {
    className: cn(styles.root, 'hide-on-print')
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    ellipsis: true
  }, realIdentity, " impersonating as ", fakeIdentity, " - you cannot change anything"))) : null;
}